import CustomTable, { ICustomTableColumn } from '../Table';
import SkeletonLoader from './index';

interface IListSummarySkeletonProps<T extends object> {
  columns: ICustomTableColumn<T>[];
}

const ListSummaryCardsSkeleton = <T extends object>({
  columns,
}: IListSummarySkeletonProps<T>) => {
  return (
    <div className="flex flex-col gap-6 w-full animate-pulse h-full">
      {/* Search & Actions Row */}
      <div className="flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <SkeletonLoader width={280} height={48} className="rounded-xl" />
          <SkeletonLoader width={150} height={48} className="rounded-xl" />
        </div>
        <SkeletonLoader width={160} height={48} className="rounded-xl" />
      </div>

      {/* Summary Cards Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map((item) => (
          <div
            key={item}
            className="flex flex-row items-center justify-between rounded-xl border border-neutral-light-200 bg-white p-4 gap-2.5 shadow-2xs"
          >
            {/* Icon Skeleton */}
            <SkeletonLoader
              width={48}
              height={48}
              className="rounded-lg shrink-0"
            />

            <div className="flex flex-col gap-2 w-full justify-between items-start">
              {/* Label Skeleton */}
              <SkeletonLoader width="60%" height={20} className="rounded" />
              {/* Value Skeleton */}
              <SkeletonLoader width="40%" height={32} className="rounded" />
            </div>
          </div>
        ))}
      </div>

      {/* Table Skeleton */}
      {columns && (
        <CustomTable columns={columns} dataSource={[]} isLoading={true} />
      )}
    </div>
  );
};

export default ListSummaryCardsSkeleton;
